module.exports = __webpack_public_path__ + "img/HighestItems.783aafb9.jpg";